var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m438 431.809c-40.804 0-74-33.196-74-74v-174c4.077-98.195 143.96-98.119 148 0v174c0 40.804-33.196 74-74 74zm0-282c-18.748 0-34 15.252-34 34v174c1.873 45.117 66.144 45.082 68 0v-174c0-18.748-15.252-34-34-34zm-364 282c-40.804 0-74-33.196-74-74v-54c4.077-98.195 143.96-98.119 148 0v54c0 40.804-33.196 74-74 74zm0-162c-18.748 0-34 15.252-34 34v54c1.873 45.117 66.144 45.082 68 0v-54c0-18.748-15.252-34-34-34zm182 162c-40.804 0-74-33.196-74-74v-284c4.077-98.195 143.96-98.119 148 0v284c0 40.804-33.196 74-74 74zm0-392c-18.748 0-34 15.252-34 34v284c1.873 45.117 66.144 45.082 68 0v-284c0-18.748-15.252-34-34-34zm256 452c0-11.046-8.954-20-20-20h-472c-26.536 1.056-26.516 38.953 0 40h472c11.046 0 20-8.954 20-20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.d63c2ef7.svg";
export { ForwardRef as ReactComponent };